import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'トップ', path: '/' },
  { label: 'ご挨拶', path: '/greeting' },
  { label: '活動の流れ', path: '/service' },
  { label: 'ご入会の流れ', path: '/enrollment' },
  { label: '選ばれる理由', path: '/reason' },
  { label: '成婚事例', path: '/success' },
  { label: '料金プラン', path: '/price' },
  { label: 'よくある質問', path: '/faq' },
  { label: 'ブログ', path: '/blog' },
  { label: 'お問い合わせ', path: '/contact' },
];

const LINE_URL = 'https://lin.ee/PNbhQI0';
const INSTAGRAM_URL = 'https://www.instagram.com/enmusubi.wahaha?igsh=eWxjM2d1eDA5N3Nv&utm_source=qr';
const FACEBOOK_URL = 'https://www.facebook.com/share/1NsTgMVW1J/?mibextid=wwXIfr';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-shadow duration-300 ${
        isScrolled ? 'shadow-lg' : ''
      }`}
      style={{ background: '#fff8f2', borderBottom: '2px solid #5a9e6f' }}
    >
      <div className="content-width h-[72px] flex items-center justify-between">
        {/* Logo */}
        <Link
          to="/"
          className="whitespace-nowrap shrink-0 flex items-center"
        >
          <img
            src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/logo.png"
            alt="縁結び 和はは"
            className="h-12 w-auto object-contain"
            style={{ background: 'transparent' }}
            fetchPriority="high"
            loading="eager"
            decoding="async"
            width={180}
            height={48}
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden xl:flex items-center gap-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={{
                fontSize: '14px',
                color: location.pathname === item.path ? '#5a9e6f' : '#4a3728',
                fontWeight: location.pathname === item.path ? '700' : '400',
              }}
              className="hover:text-[#5a9e6f] transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </Link>
          ))}
          {/* SNS Icons */}
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center w-8 h-8 rounded-full hover:opacity-80 transition-opacity shrink-0"
            style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}
            aria-label="Instagram"
          >
            <i className="ri-instagram-line text-white text-base"></i>
          </a>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center w-8 h-8 rounded-full hover:opacity-80 transition-opacity shrink-0"
            style={{ background: '#1877F2' }}
            aria-label="Facebook"
          >
            <i className="ri-facebook-fill text-white text-base"></i>
          </a>
          <a
            href={LINE_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            style={{
              background: '#06C755',
              color: '#fff',
              borderRadius: '8px',
              padding: '8px 18px',
              fontSize: '14px',
              fontWeight: '700',
            }}
            className="whitespace-nowrap hover:opacity-90 transition-opacity flex items-center gap-1 shrink-0"
          >
            <i className="ri-line-fill"></i>
            LINE相談
          </a>
        </div>

        {/* Tablet menu (simplified) */}
        <div className="hidden md:flex xl:hidden items-center gap-2">
          {[
            { label: '料金プラン', path: '/price' },
            { label: 'よくある質問', path: '/faq' },
            { label: 'お問い合わせ', path: '/contact' },
          ].map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={{
                fontSize: '13px',
                color: location.pathname === item.path ? '#5a9e6f' : '#4a3728',
                fontWeight: location.pathname === item.path ? '700' : '400',
              }}
              className="whitespace-nowrap hover:text-[#5a9e6f] transition-colors duration-200"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center w-7 h-7 rounded-full hover:opacity-80 transition-opacity shrink-0"
            style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}
            aria-label="Instagram"
          >
            <i className="ri-instagram-line text-white text-sm"></i>
          </a>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center w-7 h-7 rounded-full hover:opacity-80 transition-opacity shrink-0"
            style={{ background: '#1877F2' }}
            aria-label="Facebook"
          >
            <i className="ri-facebook-fill text-white text-sm"></i>
          </a>
          <a
            href={LINE_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            style={{ background: '#06C755', color: '#fff', borderRadius: '8px', padding: '7px 12px', fontSize: '13px', fontWeight: '700' }}
            className="whitespace-nowrap flex items-center gap-1 shrink-0"
          >
            <i className="ri-line-fill"></i>LINE
          </a>
        </div>

        {/* Mobile SNS + Hamburger */}
        <div className="md:hidden flex items-center gap-2">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center w-8 h-8 rounded-full hover:opacity-80 transition-opacity shrink-0"
            style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}
            aria-label="Instagram"
          >
            <i className="ri-instagram-line text-white text-base"></i>
          </a>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center w-8 h-8 rounded-full hover:opacity-80 transition-opacity shrink-0"
            style={{ background: '#1877F2' }}
            aria-label="Facebook"
          >
            <i className="ri-facebook-fill text-white text-base"></i>
          </a>
          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            style={{ color: '#8b4513' }}
            className="flex items-center justify-center w-10 h-10"
            aria-label="メニューを開く"
          >
            <i className={`${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isMobileOpen && (
        <div
          style={{ background: '#fff8f2', borderTop: '1px solid #e8d8cc' }}
          className="md:hidden px-4 pb-4"
        >
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={{ color: '#4a3728', fontSize: '15px' }}
              className="block py-3 border-b border-[#e8d8cc] hover:text-[#5a9e6f] transition-colors"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={LINE_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            style={{
              background: '#06C755',
              color: '#fff',
              borderRadius: '8px',
              padding: '12px 20px',
              fontSize: '15px',
              fontWeight: '700',
            }}
            className="flex items-center justify-center gap-2 mt-4"
          >
            <i className="ri-line-fill text-lg"></i>
            LINE友だち追加
          </a>
          {/* Mobile SNS Links */}
          <div className="flex items-center gap-3 mt-3">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity"
              style={{ color: '#4a3728', fontSize: '14px' }}
            >
              <span className="flex items-center justify-center w-8 h-8 rounded-full" style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
                <i className="ri-instagram-line text-white text-base"></i>
              </span>
              Instagram
            </a>
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity"
              style={{ color: '#4a3728', fontSize: '14px' }}
            >
              <span className="flex items-center justify-center w-8 h-8 rounded-full" style={{ background: '#1877F2' }}>
                <i className="ri-facebook-fill text-white text-base"></i>
              </span>
              Facebook
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
